<dw-ui-table
  [isSelectable]="true"
  (addClick)="addPackage()"
  (selectionChange)="onSelectionChange($event)"
>
  <h4 top-left>
    {{ 'Doc::Packaging' | abpLocalization }}
  </h4>
  <ng-container top-right-before-add>
    <div ngbDropdown class="me-3">
      <button
        type="button"
        class="btn btn-outline-ligth rounded-circle dropdown-toggle"
        id="dropdowntoolbar"
        ngbDropdownToggle
      >
        <i class="digi-out-three-points-horizontal"></i>
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdown">
        <button type="button" ngbDropdownItem (click)="removeSelectedPackages()">
          {{ '::Delete' | abpLocalization }}
        </button>
      </div>
    </div>
    <div>
      <button class="btn btn-outline-primary" (click)="addPackage()">
        {{ 'Doc::AddPackaging' | abpLocalization }}
      </button>
    </div>
  </ng-container>
  <ng-container header>
    <th class="w-75">{{ '::Description' | abpLocalization }}</th>
    <th class="w-25">{{ '::Quantity' | abpLocalization }}</th>
  </ng-container>
  @for (package of packagingList; track package) {
    @if (package) {
      <dw-ui-table-row [data]="package">
        <td>
          <ng-select
            class="form-control"
            id="articleId"
            bindLabel="name.current"
            bindValue="id"
            [(ngModel)]="package.articleId"
            [items]="packagings"
            (change)="articleChange($event, package)"
          >
          </ng-select>
        </td>
        <td>
          <input type="number" class="form-control" [(ngModel)]="package.quantity" />
        </td>
      </dw-ui-table-row>
    }
  }
</dw-ui-table>
